<template>
  <div>
    <b-row class="border mb-2" style="min-height: 180px;">
      <b-col
        cols="12"
        md="3"
        class="border-right d-flex align-items-center justify-content-center p-3"
      >
        <div class="text-center font-weight-bold">
          Estándar de Herraje
        </div>
      </b-col>
      <b-col
        cols="6"
        md="2"
        class="border-right d-flex flex-column"
      >
        <div
          class="option-header border-bottom text-center py-2"
          :class="{ 'text-danger': detailsForm.hardware_standard == null }"
        >
          ANSI
        </div>
        <div class="flex-fill d-flex align-items-center justify-content-center py-2">
          <b-form-checkbox
            v-model="detailsForm.hardware_standard"
            size="lg"
            value="ansi"
            :unchecked-value="null"
          />
        </div>
      </b-col>
      <b-col
        cols="6"
        md="2"
        class="border-right d-flex flex-column"
      >
        <div
          class="option-header border-bottom text-center py-2"
          :class="{ 'text-danger': detailsForm.hardware_standard == null }"
        >
          EURO
        </div>
        <div class="flex-fill d-flex align-items-center justify-content-center py-2">
          <b-form-checkbox
            v-model="detailsForm.hardware_standard"
            size="lg"
            value="euro"
            :unchecked-value="null"
          />
        </div>
      </b-col>
      <b-col
        cols="12"
        md="5"
        class="d-flex align-items-center justify-content-center py-1"
      >
        <div class="d-flex flex-wrap justify-content-center">
          <div class="text-center mx-3">
            <b-img
              :src="euroAnsiImg"
              fluid
              class="image-section"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="border mb-2" style="min-height: 180px;">
      <b-col cols="12" md="8" class="border-right">
        <b-row class="border-bottom pb-2 pb-md-0">
          <b-col cols="12" md="5" class="border-right d-flex align-items-center justify-content-center p-2" style="height: 95px;">
            <p class="text-center font-weight-bold mb-0">
              Backset <br>
              (Distancia de la Entrada)
            </p>
          </b-col>
          <b-col cols="12" md="7" class="d-flex align-items-center px-4" >
            <ValidationProvider rules="required" name="Backset" style="width: 300px;" v-slot="{ valid, errors }">
              <b-input-group append="cm" >
                <b-form-input
                  v-model.number="detailsForm.backset"
                  type="number"
                  min="0"
                  step="1"
                  :state="errors[0] ? false : (valid ? true : false)"
                />
              </b-input-group>
            </ValidationProvider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="5" class="border-right d-flex align-items-center justify-content-center p-2" style="height: 95px;">
            <p class="text-center font-weight-bold mb-0">
              Axe <br>
              (Distancia entre ejes)
            </p>
          </b-col>
          <b-col cols="12" md="7" class="d-flex align-items-center px-4">
            <ValidationProvider rules="required" name="axe" style="width: 300px;" v-slot="{ valid, errors }">
              <b-input-group append="cm">
                <b-form-input
                  v-model.number="detailsForm.axe_distance"
                  type="number"
                  min="0"
                  step="1"
                  :state="errors[0] ? false : (valid ? true : false)"
                />
              </b-input-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" md="4" class="d-flex align-items-center justify-content-center py-2">
        <b-img
          :src="backsetAxe"
          fluid
          class="image-section"
        />
      </b-col>
    </b-row>

    <b-row class="border mb-2">
      <b-col cols="12" md="3" class="border-right d-flex align-items-center justify-content-center py-2">
        <p class="text-center font-weight-bold mb-0">
          Dimensiones de la placa frontal del herraje
        </p>
      </b-col>

      <b-col cols="6" md="2" class="border-right">
        <div class="border-bottom d-flex align-items-center justify-content-center" style="height: 70px;">
          <b-form-radio v-model="detailsForm.faceplate_type" value="Redonda" />
          <span
            class="ml-2 font-weight-bold"
            :class="{ 'text-danger': detailsForm.faceplate_type == null }"
          >Redonda</span>
        </div>
        <div class="border-bottom d-flex align-items-center justify-content-center" style="height: 70px;">
          <p class="mb-0 font-weight-bold">Ancho (X)</p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="height: 70px;">
          <p class="mb-0 font-weight-bold">Largo (Y)</p>
        </div>
      </b-col>

      <b-col cols="6" md="3" class="border-right">
        <div class="border-bottom d-flex align-items-center justify-content-center" style="height: 70px;">
          <b-form-radio v-model="detailsForm.faceplate_type" value="Cuadrada" />
          <span
            class="ml-2 font-weight-bold"
            :class="{ 'text-danger': detailsForm.faceplate_type == null }"
          >Cuadrada</span>
        </div>
        <div class="border-bottom d-flex align-items-center px-3" style="height: 70px;">
          <ValidationProvider rules="required" name="faceplate_width" style="width: 300px;" v-slot="{ valid, errors }">
            <b-input-group append="cm">
              <b-form-input
                v-model.number="detailsForm.faceplate_width"
                type="number"
                min="0"
                step="1"
                :state="errors[0] ? false : (valid ? true : false)"
              />
            </b-input-group>
          </ValidationProvider>
        </div>
        <div class="d-flex align-items-center px-3" style="height: 70px;">
          <ValidationProvider rules="required" name="faceplate_width" style="width: 300px;" v-slot="{ valid, errors }">
            <b-input-group append="cm">
              <b-form-input
                v-model.number="detailsForm.faceplate_length"
                type="number"
                min="0"
                step="1"
                :state="errors[0] ? false : (valid ? true : false)"
              />
            </b-input-group>
          </ValidationProvider>
        </div>

      </b-col>

      <b-col
        cols="12"
        md="4"
        class="d-flex align-items-center justify-content-center py-2"
      >
        <b-img
          :src="facePlate"
          fluid
          class="faceplate-image"
        />
      </b-col>
    </b-row>

    <b-row class="justify-content-center align-items-center my-4">
      <b-col cols="12" md="6" class="d-flex justify-content-center">
        <div class="image-wrapper">
          <b-img
            :src="cerraduraSaltoImg"
            fluid
            class="cerradura-img"
          />
        </div>
      </b-col>

      <b-col cols="12" md="6" class="d-flex justify-content-center">
        <div class="image-wrapper">
          <b-img
            :src="doorDetail"
            fluid
            class="door-detail-img"
          />
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="px-0">
        <div
          v-for="field in dimensionFields"
          :key="field.model"
          class="mb-3"
        >
          <b-row align-v="center">
            <b-col cols="12" md="8" class="mb-2 mb-md-0 px-0">
              <Label
                v-if="field.inputType == 'radio'"
                :label="field.label"
                :blank="detailsForm[field.model] === null ? null : 'true'"
                :show-reset="detailsForm[field.model] == true || detailsForm[field.model] == false"
                @reset="detailsForm[field.model] = null"
              />
              <Label
                v-else
                :label="field.label"
                :blank="detailsForm[field.model] === null || detailsForm[field.model] === '' ? null : 'true'"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="d-flex justify-content-md-end justify-content-start px-0"
            >
              <ValidationProvider v-if="field.inputType == 'input'" rules="required" name="axe" style="width: 300px;" v-slot="{ valid, errors }">
                <b-input-group append="cm" class="w-100 w-md-auto pr-2">
                  <b-form-input
                    v-model.number="detailsForm[field.model]"
                    type="number"
                    min="0"
                    step="1"
                    :state="errors[0] ? false : (valid ? true : false)"
                  />
                </b-input-group>
              </ValidationProvider>
              <b-form-group v-if="field.inputType == 'radio'" class="w-100 w-md-auto pr-2 mb-0">
                <b-radio-group size="lg" v-model="detailsForm[field.model]">
                  <b-radio :value="true">Si</b-radio>
                  <b-radio :value="false">No</b-radio>
                </b-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'
import SelectableCard from '../../../configurators/SelectableCard'

export default {
  name: 'cerraduraSalto',
  components: {
    Label,
    Button,
    SelectableCard,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      euroAnsiImg: require('../../../../../../assets/images/control_acceso/euro_ansi.webp'),
      facePlate: require('../../../../../../assets/images/control_acceso/face_plate.webp'),
      backsetAxe: require('../../../../../../assets/images/control_acceso/backset_axe.webp'),
      cerraduraSaltoImg: require('../../../../../../assets/images/control_acceso/cerradura_salto.png'),
      doorDetail: require('../../../../../../assets/images/control_acceso/door_detail.png'),
      dimensionFields: [
        {
          model: 'door_thickness',
          label: 'Espesor de la puerta (X1)',
          inputType: 'input'
        },
        {
          model: 'lock_thickness',
          label: 'Espesor de la cerradura (X2)',
          inputType: 'input'
        },
        {
          model: 'handle_height',
          label: 'Altura de la manilla con respecto al centro de la cerradura (X3)',
          inputType: 'input'
        },
        {
          model: 'handle_offset',
          label: 'Distancia entre el perfil de la puerta y el centro de la manilla (X4)',
          inputType: 'input'
        },
        {
          model: 'cover_plate',
          label: 'Cover Plate o placa tapa huecos',
          inputType: 'radio'
        }
      ],
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    })
  }
}
</script>

<style scoped>
.image-section {
  width: 130px;
  height: 100%;
  object-fit: contain;
}

.image-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cerradura-img{
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.door-detail-img{
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.faceplate-image{
  max-width: 100%;
  max-height: 195px;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* @media (max-width: 768px) {
  .door-detail-img {
    max-height: 200px;
  }
} */

</style>